import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector", "dateField"]

  connect() {
    this.toggleDateField()
  }

  toggleDateField() {
    const showDateField = this.selectorTarget.value === "until_date"

    this.dateFieldTarget.hidden = !showDateField
    this.dateFieldTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !showDateField
    })
  }
}
